module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui segment good-card row"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column eight wide computer sixteen wide tablet"
  }, [_c('div', [_c('div', {
    staticClass: "badge-wrapper"
  }, [_c('discount-tag', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _vm._l((_vm.item.badges), function(badge) {
    return _c('div', {
      staticClass: "ui labels"
    }, [_c('a', {
      staticClass: "ui label",
      style: ({
        backgroundColor: '#' + badge.color,
        color: '#210404'
      })
    }, [_vm._v(_vm._s(badge.label))])])
  })], 2)]), _vm._v(" "), _c('g-zoom', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column eight wide computer sixteen wide tablet"
  }, [_c('h1', [_vm._v(_vm._s(_vm.item.goods_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMoreDescription()
      }
    }
  }, [_vm._v("Lasīt vairāk")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "ui tag labels pa-tag-wrapper"
  }, [_c('price-tag', {
    attrs: {
      "item": _vm.item,
      "oneline": true
    }
  }), _vm._v(" "), (_vm.item.bail > 0) ? _c('a', {
    staticClass: "ui green label"
  }, [_vm._v("Drošības nauda: " + _vm._s(_vm.item.bail) + " €")]) : _vm._e(), _vm._v(" "), _c('auto-ship', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), (_vm.item.deposit != 0) ? _c('div', {
    staticClass: "deposit-info"
  }, [_vm._v("\n                              + Depozīts: " + _vm._s(_vm.item.deposit) + " €\n\t\t                    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui items"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui right floated"
  }, [_c('div', {
    staticClass: "ui left floated inline fields"
  }, [_c('label', {
    staticStyle: {
      "width": "85px",
      "text-align": "right"
    }
  }, [_vm._v("Pasūtīšu:  \n                                                        x")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "type": "text",
      "placeholder": "skaits",
      "number": ""
    },
    domProps: {
      "value": _vm.cartItem.order
    },
    on: {
      "keyup": function($event) {
        return _vm.updateCartItemOrder($event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.cartItem.isrentable == 1) ? _c('div', {
    staticClass: "ui left floated inline fields"
  }, [_c('label', {
    staticStyle: {
      "width": "85px",
      "text-align": "right"
    }
  }, [_vm._v("Atgriezīšu:  \n                                                        x")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "type": "text",
      "placeholder": "skaits",
      "number": ""
    },
    domProps: {
      "value": _vm.cartItem.return
    },
    on: {
      "keyup": function($event) {
        return _vm.updateCartItemReturn($event.target.value)
      }
    }
  })])]) : _vm._e()])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.checkIfInCart(_vm.item)) ? _c('div', {
    staticClass: "ui bottom attached button",
    attrs: {
      "id": "add-first-item-button"
    },
    on: {
      "click": function($event) {
        return _vm.addItemToCart(_vm.item, _vm.item.id, $event.target)
      }
    }
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v(" Pievienot\n                        ")]) : _c('div', {
    staticClass: "ui three bottom attached buttons"
  }, [_c('div', {
    staticClass: "ui button minus-icon-container",
    on: {
      "click": function($event) {
        return _vm.reduceItemInCart(_vm.item)
      }
    }
  }, [_c('i', {
    staticClass: "minus icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui vertical animated button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_c('div', {
    staticClass: "ui hidden content"
  }, [_vm._v("Uz grozu")]), _vm._v(" "), _c('div', {
    staticClass: "ui visible content"
  }, [_c('i', {
    staticClass: "cart icon"
  }), _vm._v("\n                                    " + _vm._s(_vm.howManyInCart(_vm.item)) + " gab.\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.addItemToCart(_vm.item, _vm.item.id, $event.target)
      }
    }
  }, [_c('i', {
    staticClass: "add icon popup",
    attrs: {
      "id": 'good_item_' + _vm.item.id,
      "data-content": "Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet zemāk līdzīgās preces."
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column long-description-box"
  }, [_c('p', {
    attrs: {
      "id": "long-description"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.long_description)
    }
  })])])])]), _vm._v(" "), _c('div', [(_vm.replacement.length > 0) ? _c('replacement-goods', {
    attrs: {
      "goods": _vm.replacement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.complementary.length > 0) ? _c('complementary-goods', {
    attrs: {
      "goods": _vm.complementary
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c9f3391!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodPage/GoodCard.vue
// module id = 360
// module chunks = 1